import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  NOTIFICATIONS_LIST,
  NOTIFICATIONS_NEW,
  NOTIFICATIONS_USER_LIST,
  NOTIFICATIONS_GROUP_LIST,
} from "./actionTypes"

import {
  notificationsListSuccess,
  notificationsListError,
  notificationsNewSuccess,
  notificationsNewError,
  notificationsUserListSuccess,
  notificationsUserListError,
  notificationsGroupListSuccess,
  notificationsGroupListError,
} from "./actions"

import {
  apiGetNotificationsList,
  apiPostNotificationsNew,
} from "../../api/calls/notifications"

import {
  apiGetUsersSelectList,
} from "../../api/calls/users";

import {
  apiGetGroupSelectList
} from "../../api/calls/groups";

function* notificationsList({payload: data}) {
  try {
    const response = yield call(apiGetNotificationsList, data)
    yield put(notificationsListSuccess(response))
  } catch (error) {
    yield put(notificationsListError(error))
  }
}

function* notificationsNew({payload: data}) {
  try {
    const response = yield call(apiPostNotificationsNew, data)
    yield put(notificationsNewSuccess(response))
  } catch (error) {
    yield put(notificationsNewError(error))
  }
}

function* notificationsUserList({payload: data}) {
  try {
    const response = yield call(apiGetUsersSelectList, data)
    yield put(notificationsUserListSuccess(response))
  } catch (error) {
    yield put(notificationsUserListError(error))
  }
}

function* notificationsGroupList({payload: data}) {
  try {
    const response = yield call(apiGetGroupSelectList, data)
    yield put(notificationsGroupListSuccess(response))
  } catch (error) {
    yield put(notificationsGroupListError(error))
  }
}

export function* watchNotificationsList() {
  yield takeEvery(NOTIFICATIONS_LIST, notificationsList);
}

export function* watchNotificationsNew() {
  yield takeEvery(NOTIFICATIONS_NEW, notificationsNew);
}

export function* watchNotificationsUserList() {
  yield takeEvery(NOTIFICATIONS_USER_LIST, notificationsUserList);
}

export function* watchNotificationsGroupList() {
  yield takeEvery(NOTIFICATIONS_GROUP_LIST, notificationsGroupList);
}

function* notificationsSaga() {
  yield all([
    fork(watchNotificationsList),
    fork(watchNotificationsNew),
    fork(watchNotificationsUserList),
    fork(watchNotificationsGroupList),
  ]);
}

export default notificationsSaga
